module.exports = __webpack_public_path__ + "hopper-src-icon.png?135139db562046fbae373398e094d7b8";